import React from 'react';
import { Card, CardActionArea, Typography, Box } from '@mui/material';
import { Event, Groups, Person, Category, Festival, Class, ArchiveOutlined, AirlineSeatReclineNormal, Settings, SlideshowOutlined, Feedback, FileDownload, CloudUpload, Description, PriorityHigh, Public } from '@mui/icons-material';
import * as routes from '../routes/routes';
import { Link } from 'react-router-dom';
import Grid2 from '@mui/material/Unstable_Grid2/Grid2';

const AdminActionsPage = () => {
    // keep your items and colors as you set them; now grouped for clarity
    const groups = [
        {
            title: 'Content',
            items: [
                { name: 'Categories', description: 'Create and edit categories', link: routes.CATEGORY_PAGE, icon: <Category />, bg: 'primary.main' },
                { name: 'Divisions', description: 'Create and edit divisions', link: routes.DIVISION_PAGE, icon: <Class />, bg: 'primary.main' },
                { name: 'Teams', description: 'Create and edit teams by assigning team members', link: routes.TEAM_PAGE, icon: <Groups />, bg: 'primary.main' },
                { name: 'Events', description: 'Create and edit events. Assign Judges to events', link: routes.EVENT_PAGE, icon: <Event />, bg: 'primary.main' },
            ],
        },
        {
            title: 'Administration',
            items: [
                { name: 'Competitions', description: 'Create competitions and set the global default competition', link: routes.COMPETITION_PAGE, icon: <Festival />, bg: 'secondary.main' },
                { name: 'Users', description: 'Edit users and assign them to teams or events', link: routes.USER_PAGE, icon: <Person />, bg: 'secondary.main' },
                { name: 'Registration Settings', description: 'Control settings related to the registration form', link: routes.REGISTRATION_SETTINGS_PAGE, icon: <Settings />, bg: 'secondary.main' },
            ],
        },
        {
            title: 'Data / Import & Export',
            items: [
                { name: 'Import / Export', description: 'Import and export teams, events and users', link: routes.EXPORT_PAGE, icon: <CloudUpload />, bg: 'success.main' },
                { name: 'Base Scoresheet', description: 'Base Scoresheet within a competition', link: routes.BASE_SCORESHEET_PAGE, icon: <Description />, bg: 'success.main' },
                { name: 'History', description: 'View history of actions taken in the application', link: routes.HISTORY, icon: <ArchiveOutlined />, bg: 'success.main' },
            ],
        },
        {
            title: 'Event Tools',
            items: [
                { name: 'Slide Show', description: 'Create a slide show during the event', link: routes.SLIDE_SHOW_TIMER_PAGE, icon: <SlideshowOutlined />, bg: 'warning.main' },
                { name: 'Penalties Report', description: 'See most used penalties for the competition', link: routes.PENALTIES_REPORT, icon: <Feedback />, bg: 'warning.main' },
                { name: 'Waitroom', description: 'View the incoming events and sponsors', link: routes.WAITROOM_PAGE, icon: <AirlineSeatReclineNormal />, bg: 'warning.main' },
            ],
        },
        {
            title: 'Other',
            items: [
                { name: 'Liability Form Upload', description: 'Upload liability release forms', link: routes.LIABILITY_PAGE, icon: <PriorityHigh />, bg: 'info.main' },
                { name: 'Global Settings', description: 'Show final scores and the global default competition.', link: routes.GLOBAL_SETTINGS_PAGE, icon: <Public />, bg: 'info.main' },
                { name: 'Results (Old View)', description: 'The old results page', link: routes.RESULTS_PAGE, icon: <Public />, bg: 'info.main' },
            ],
        },
    ];

    const cardSx = {
        height: '100%',
        width: '100%',
        minHeight: 120,
        borderRadius: 2,
        boxShadow: 3,
        bgcolor: 'background.paper',
        overflow: 'visible',
        margin: 0,
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        transition: 'transform .18s ease, box-shadow .18s ease',
        zIndex: 0,
        '&:hover': { zIndex: 2, transform: 'translateY(-6px)', boxShadow: 14 },
    };

    return (
        <Grid2 container direction="column" sx={{ p: { xs: 2, sm: 3 }, mx: 'auto', width: '100%' }}>
            <Typography variant='h4' fontWeight={700} sx={{ mb: 2 }}>
                Admin Actions Page
            </Typography>

            {groups.map((group, gi) => (
                <Box key={gi} sx={{ mb: 4 }}>
                    <Typography variant='h6' sx={{ mb: 1, fontWeight: 700 }}>{group.title}</Typography>

                    <Grid2 container spacing={3} sx={{ alignItems: 'stretch' }}>
                        {group.items.map((v, k) => (
                            <Grid2 item xs={12} sm={6} md={4} lg={3} key={k} sx={{ display: 'flex' }}>
                                <Card sx={cardSx}>
                                    <CardActionArea
                                        component={Link}
                                        to={v.link}
                                        sx={{
                                            flex: 1,
                                            width: '100%',
                                            display: 'flex',
                                            alignItems: 'center',
                                            px: 3,
                                            py: 2,
                                            borderRadius: 2,
                                            boxSizing: 'border-box',
                                        }}
                                    >
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, width: '100%' }}>
                                            <Box sx={{ width: 56, height: 56, display: 'flex', alignItems: 'center', justifyContent: 'center', bgcolor: v.bg || 'primary.main', color: 'common.white', borderRadius: 1 }}>
                                                {React.isValidElement(v.icon) ? React.cloneElement(v.icon, { sx: { fontSize: 36, color: 'inherit' } }) : v.icon}
                                            </Box>
                                            <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                                                <Typography variant='h6' sx={{ fontSize: 17, fontWeight: 700 }}>{v.name}</Typography>
                                                <Typography variant='body2' color='text.secondary' sx={{ fontSize: 13 }}>{v.description}</Typography>
                                            </Box>
                                        </Box>
                                    </CardActionArea>
                                </Card>
                            </Grid2>
                        ))}
                    </Grid2>
                </Box>
            ))}
        </Grid2>
    );
};

export default AdminActionsPage;

